<template>
    <div class="listing-detail-banner broker" ref="banner" :style="rootStyle">
        <!-- mobile start -->
        <template v-if="isMobileSize">
            <div class="mobile-fixed-banner" v-sticky="{ class: 'fixed' }">
                <div class="button">
                    <div class="left-btn" @click="putAway">
                        <span class="btn-putAway iconfont icon-arrow-up"></span>
                    </div>
                    <div class="right-btn">
                        <div class="item share" v-if="notApp" @click="sharePop">
                            <span class="iconfont icon-big-normal-share"></span>
                        </div>
                    </div>
                </div>
            </div>
            <Addr
                v-if="info.streetAddress || info.cityAddress"
                class="address mobile-banner-address"
            />
            <div class="mg-container">
                <Swiper
                    class="swiper-mobile swiper"
                    trackSource="detail-info-img"
                    v-bind="options"
                    @init="onSwiperReady"
                    @slideChange="handleSlideChange"
                >
                    <Slide
                        v-for="(item, index) in allImages"
                        :key="index"
                        :class="`slide-pc slide-${item.length}`"
                    >
                        <div
                            class="swiper-box"
                            @click="touched(index, $event, item)"
                            :title="$t('md-sold-detail.clickToZoomin')"
                        >
                            <div
                                class="swiper-video"
                                v-if="item.type == 'video'"
                            >
                                <img-box
                                    v-if="item.video.videoPreview"
                                    :src="item.video.videoPreview"
                                    :alt="videoImgAlt"
                                ></img-box>
                                <div class="play"></div>
                            </div>
                            <div
                                class="swiper-video"
                                v-else-if="item.type == '3d'"
                            >
                                <img-box
                                    :src="item.preview"
                                    :alt="videoImgAlt"
                                ></img-box>
                            </div>
                            <img-box
                                v-else
                                @load="onImgLoad(index, $event)"
                                :lazy="lazyload"
                                :src="item"
                                :alt="imgAlt"
                                class="swiper-img"
                            ></img-box>
                        </div>
                    </Slide>
                    <span
                        v-if="allImages.length > 1"
                        class="house-count"
                        @click="touched(0)"
                    >
                        <span class="iconfont icon-pic"></span>
                        <span class="swiper-num-pagination">
                            {{
                                curPage == 0
                                    ? allImages.length
                                    : curPage + '/' + allImages.length
                            }}
                        </span>
                    </span>
                </Swiper>
            </div>
        </template>
        <!-- mobile end -->
        <!-- pc start -->
        <template v-else>
            <div
                class="pc-fixed-banner"
                :class="{ fixed: showFixedBanner }"
            >
                <div class="banner-box f-col">
                    <div class="center">
                        <div class="price-address">
                            <price class="price"></price>
                            <est-price class="est-price"></est-price>
                            <!-- address start -->
                            <!-- address start -->
                            <template
                                v-if="info.streetAddress || info.cityAddress"
                            >
                                <Addr tag="div" class="address" />
                            </template>
                            <!-- address end -->
                        </div>
                        <div class="save-share-tour" v-show="showFixedBanner">
                            <span class="item share">
                                <i
                                    class="iconfont icon-v2-share-Normal default"
                                ></i>
                                <!-- hover share icon -->
                                <i
                                    class="iconfont icon-v2-share-hover hover"
                                ></i>
                                <span class="label">{{
                                    $t('md-sold-detail.share')
                                }}</span>
                                <share-popper
                                    class="popper"
                                    :shares="shares"
                                    :theme="theme"
                                    :listingId="info.id"
                                ></share-popper>
                            </span>
                            <span class="item request" @click="request">{{
                                cmpRequestButtonText
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="banner-top mg-container" ref="bannerTop">
                <template v-if="info.streetAddress || info.cityAddress">
                    <Addr class="address" />
                </template>
            </div>

            <!-- pc top fixed banner end -->
            <bread-crumb
                v-if="!isMobileSize"
                theme="broker"
                :detailInfo="info"
            ></bread-crumb>

            <Swiper
                class="swiper-pc swiper"
                trackSource="detail-info-img"
                v-bind="options"
                @init="onSwiperReady"
                @slideChange="handleSlideChange"
            >
                <Slide
                    v-for="(items, index) in pictureTerms"
                    :key="index"
                    :class="`slide-pc slide-${items.length}`"
                >
                    <div class="slide-left photo-item-pc">
                        <div
                            class="swiper-box"
                            @click="touched(index * 6, $event, items[0])"
                        >
                            <div
                                class="swiper-video"
                                v-if="items[0].type == '3d'"
                            >
                                <img-box
                                    :src="items[0].preview"
                                    :persent="0.5"
                                    :alt="videoImgAlt"
                                ></img-box>
                            </div>
                            <img-box
                                v-else
                                @load="onImgLoad(index * 6, $event)"
                                :lazy="lazyload"
                                :src="items[0]"
                                :persent="0.5"
                                :alt="imgAlt"
                                class="swiper-img"
                            ></img-box>
                        </div>
                    </div>
                    <div class="slide-mid clearfix">
                        <div
                            :key="item_index"
                            v-for="(item, item_index) in items.slice(1, 4)"
                            class="img-item photo-item-pc"
                        >
                            <div
                                class="swiper-box"
                                @click="
                                    touched(
                                        index * 6 + item_index + 1,
                                        $event,
                                        item
                                    )
                                "
                            >
                                <img-box
                                    @load="
                                        onImgLoad(
                                            index * 6 + item_index + 1,
                                            $event
                                        )
                                    "
                                    :lazy="lazyload"
                                    :src="item"
                                    :alt="imgAlt"
                                    class="swiper-img"
                                ></img-box>
                            </div>
                        </div>
                    </div>
                    <div class="slide-right clearfix">
                        <div
                            :key="item_index"
                            v-for="(item, item_index) in items.slice(4)"
                            class="img-item photo-item-pc"
                        >
                            <div
                                class="swiper-box"
                                @click="
                                    touched(
                                        index * 6 + item_index + 4,
                                        $event,
                                        item
                                    )
                                "
                            >
                                <img-box
                                    @load="
                                        onImgLoad(
                                            index * 6 + item_index + 4,
                                            $event
                                        )
                                    "
                                    :lazy="lazyload"
                                    :src="item"
                                    :alt="imgAlt"
                                    class="swiper-img"
                                ></img-box>
                            </div>
                        </div>
                    </div>
                </Slide>
                <div
                    class="swiper-button-prev iconfont icon-chevron_right"
                ></div>
                <div
                    class="swiper-button-next iconfont icon-chevron_right"
                ></div>
                <span
                    class="house-count"
                    v-if="allImages.length > 1"
                    @click="touched()"
                    style="cursor: pointer"
                >
                    <span class="iconfont icon-pic"></span
                    >{{
                        $t('md-sold-detail.seeAllPhotos', {
                            count: allImages.length
                        })
                    }}</span
                >
            </Swiper>
        </template>
        <!-- pc end -->
        <PSwp
            :options="photoswipeOption"
            ref="pswp"
            defaultSize="1200x750"
            trackSource="detail-info-img"
        ></PSwp>
    </div>
</template>

<script>
import common from '../_mixins/banner';
import price from './price.vue';
import Addr from '../_components/address.vue';
import EstPrice from '../_components/est-price.vue';
export default {
    mixins: [common],
    components: { price, Addr, EstPrice },
    data: function() {
        return {
            mobileStep: 1,
            pcStep: 6,
            pictureTerms: [],
            theme: 'broker',
            showFixedBanner: false
        };
    },
    computed: {
        rootStyle() {
            return this.isMobileSize
                ? {
                    'max-width': '100vw'
                }
                : {};
        }
    },
    created() {
        let i = 0;
        while (i < this.allImages.length) {
            let items = [];
            for (let j = 0; j < 6; j++) {
                if (i + j < this.allImages.length) {
                    items.push(this.allImages[i + j]);
                }
            }
            this.pictureTerms.push(items);
            i = i + 6;
        }
    },
    methods: {
        onScroll() {
            let swiper = this.photoswipeOption.mySwiper;
            if (!swiper) {
                return; 
            }
            let rect = swiper.el.getBoundingClientRect();
            if (rect.top < 0) {
                this.showFixedBanner = true;
            } else {
                this.showFixedBanner = false;
            }
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

@mixin house-count() {
    position: absolute;
    color: white;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 18px;
}
$right-width: 320px;
.listing-detail-banner.broker {
    position: relative;
    .swiper {
        height: 30vw;
        overflow: hidden;
        .swiper-button-prev,
        .swiper-button-next {
            position: absolute;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background-color: rgba(0, 0, 0, 0.3);
            background-image: none;
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
            font-size: 20px;
            color: #fff;
            text-align: center;
            cursor: pointer;
            &::before {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(calc(-50% + 3px), -50%);
            }
            &.swiper-button-disabled {
                opacity: 0.5;
            }
            &:hover {
                background-color: var(--color-theme);
            }
            &:after {
                display: none;
            }
        }
        .swiper-button-prev {
            left: 20px;
            &::before {
                transform: translate(calc(-50% - 3px), -50%) rotate(180deg);
            }
        }
        .swiper-button-next {
            right: 20px;
        }
        .house-count {
            @include house-count;
            z-index: 2;
        }
        .swiper-slide {
            height: 100%;
            width: 100%;
            display: flex;
        }
        .swiper-box {
            height: 100%;
            width: 100%;
            cursor: pointer;
            .swiper-img {
                width: 100%;
                height: 100%;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .swiper-video {
                height: 100%;
                position: relative;
                background: black;
                .play {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: url('//static.chimeroi.com/site3/images/play.png');
                    background-size: cover;
                    height: 60px;
                    width: 60px;
                }
                .img-box {
                    height: 100%;
                }
            }
        }
        .slide-left,
        .slide-mid,
        .slide-right {
            img {
                border-radius: 5px;
            }
        }
        .slide-left,
        .slide-mid {
            width: 40%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            position: relative;
        }
        .slide-right {
            width: 20%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            position: relative;
            margin-right: 10px;
            .photo-item-pc {
                width: 100%;
                height: calc(50% - 5px);
                &:nth-child(1) {
                    margin-bottom: 10px;
                }
            }
        }
        .slide-left {
            margin-right: 10px;
            margin-left: 10px;
        }
        .slide-mid {
            margin-right: 10px;
            .photo-item-pc {
                height: calc(50% - 5px);
                &:nth-child(1) {
                    width: 100%;
                    margin-bottom: 10px;
                }
                &:nth-of-type(2) {
                    margin-right: 10px;
                    width: calc(50% - 5px);
                }
                &:nth-of-type(3) {
                    width: calc(50% - 5px);
                }
            }
        }
    }
}
</style>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-sold-detail.broker {
    // mobile top bannner
    .mobile-fixed-banner {
        background-color: #fff;
        box-shadow: 0 1px 0 0 #dadada;
        &.fixed {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 100;
        }
        .button {
            padding: 0 15px;
            height: 45px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid rgba(255, 255, 255, 0.1);
        }
        .left-btn {
            color: var(--color-title);
            .btn-putAway {
                transform: rotate(-90deg);
                display: inline-block;
            }
            .iconfont {
                font-size: 24px;
            }
        }
        .right-btn {
            .item {
                margin-right: 20px;
                display: inline-block;
                &:last-of-type {
                    margin-right: 0;
                }
                &.share {
                    color: var(--color-title);
                    .iconfont {
                        font-size: 22px;
                    }
                }
            }
        }
    }
    .mobile-banner-address {
        padding: 15px;
        .street,
        .city {
            font-size: 16px;
            color: var(--color-title);
            font-family: var(--font-bold);
            display: inline;
        }
    }
    .swiper.swiper-mobile {
        height: 258px;
        overflow: visible;
        .swiper-wrapper .swiper-slide {
            padding: 0 2.5px;
            .swiper-box {
                border-radius: 5px;
                overflow: hidden;
            }
        }
        .house-count {
            font-size: 14px;
            padding: 6px 13px;
            right: 10px;
            bottom: 10px;
        }
    }
    // pc top banner
    .pc-fixed-banner {
        width: 100%;
        min-height: 80px;
        padding: 40px 0;
        box-shadow: 0 8px 20px 0 rgba(0, 10, 30, 0.05);
        background-color: #ffffff;
        -webkit-transition: opacity 0.3s ease;
        -moz-transition: opacity 0.3s ease;
        -ms-transition: opacity 0.3s ease;
        -o-transition: opacity 0.3s ease;
        transition: opacity 0.3s ease;
        position: fixed;
        top: 0;
        left: 0;
        opacity: 0;
        visibility: hidden;
        &.fixed {
            visibility: visible;
            opacity: 1;
            z-index: var(--level-medium);
        }
        .banner-box {
            display: flex;
            justify-content: center;
            .center {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex: 1;
                .save-share-tour {
                    .item {
                        cursor: pointer;
                        text-align: center;
                        display: inline-block;
                        height: 40px;
                        margin-right: 40px;
                        &:last-child {
                            margin-right: 0;
                        }
                        > .iconfont {
                            font-size: 20px;
                            display: block;
                        }
                        .label {
                            font: 12px var(--font-normal);
                            color: var(--color-label);
                            line-height: 15px;
                        }
                        &.share {
                            position: relative;
                            .default {
                                color: var(--color-label);
                                display: block;
                            }
                            .hover {
                                color: #03c9ff;
                                display: none;
                            }
                            &:hover {
                                .default {
                                    display: none;
                                }
                                .hover {
                                    display: block;
                                }
                                .popper {
                                    visibility: visible;
                                }
                            }
                            .popper {
                                position: absolute;
                                top: 100%;
                                left: 50%;
                                padding-top: 15px;
                                z-index: var(--level-medium);
                                transform: translateX(-50%);
                                visibility: hidden;
                            }
                        }
                        &.request {
                            position: relative;
                            vertical-align: top;
                            padding: 10px 18px;
                            border-radius: 20px;
                            font-size: 16px;
                            font-family: var(--font-bold);
                            max-width: 250px;
                            @include ellipsis();
                            @include color-button();
                        }
                    }
                }
            }
            .est-price {
                margin: -10px 0 0 10px;
                display: inline-block;
            }
            .address {
                max-width: 600px;
                margin-top: 10px;
                @media (max-width: 1209px) {
                    max-width: 400px;
                }
                .street,
                .city {
                    display: inline-block;
                    font-size: 14px;
                    color: var(--color-label);
                }
                .street {
                    font-family: var(--font-bold);
                }
            }
        }
    }
    &.pc .banner-top {
        padding: 15px 0;
        .address {
            .street,
            .city {
                display: inline;
                color: var(--color-title);
                font-family: var(--font-bold);
                font-size: 20px;
                line-height: 24px;
            }
        }
    }
    .swiper.swiper-pc {
        .house-count {
            right: 20px;
            bottom: 20px;
            font-size: 16px;
            padding: 8px 20px;
        }
    }
}
</style>
